module.exports = {
  locales: ["en", "da", "de", "es", "fr", "no", "pt", "se", "tl", "it", "he", "tr", "hu", "th", "zh-CN"],
  defaultLocale: "en",
  pages: {
    "*": ["nextmark"],
  },
  localeDetection: true,
};
